import { useState } from 'react';
import { Box, Typography, TextField, IconButton, Drawer } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { tokens } from '../../theme/tokens';
import { askCopilot } from '../../hooks/useCopilot';

const CaseCopilotDrawer = ({ open, onClose, caseId }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [sending, setSending] = useState(false);

  const handleSend = async (userInput) => {
  if (!userInput.trim() || sending) return;
  const newMessages = [...messages, { role: 'user', content: userInput }];
  setMessages(newMessages);
  setInput('');
  setSending(true);

  try {
    const reply = await askCopilot(caseId, newMessages);
    setMessages([...newMessages, { role: 'assistant', content: reply }]);
  } catch (err) {
    console.error(err);
    setMessages([...newMessages, { role: 'assistant', content: 'Hubo un error al responder. Intenta de nuevo.' }]);
  } finally {
    setSending(false);
  }
};

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: 420, maxWidth: '92vw' } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 2.5, borderBottom: `1px solid ${tokens.colors.line}` }}>
        <Box sx={{ width: 34, height: 34, borderRadius: `${tokens.radius.sm}px`, backgroundImage: tokens.gradient.main, display: 'grid', placeItems: 'center' }}>
          <AutoAwesomeIcon sx={{ fontSize: 18, color: '#08131a' }} />
        </Box>
        <Box>
          <Typography sx={{ fontSize: 15, fontWeight: 700 }}>Copiloto</Typography>
          <Typography sx={{ fontSize: 12, color: tokens.colors.muted }}>Con contexto de este expediente</Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ ml: 'auto' }}><CloseIcon /></IconButton>
      </Box>

      <Box sx={{ flex: 1, overflowY: 'auto', p: 2.5, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {messages.map((m, i) => (
          <Box
            key={i}
            sx={{
              maxWidth: '88%', p: 1.75, borderRadius: '15px', fontSize: 14,
              alignSelf: m.role === 'user' ? 'flex-end' : 'flex-start',
              backgroundImage: m.role === 'user' ? tokens.gradient.main : 'none',
              backgroundColor: m.role === 'user' ? 'transparent' : tokens.colors.panel,
              border: m.role === 'user' ? 'none' : `1px solid ${tokens.colors.line}`,
              color: m.role === 'user' ? '#08131a' : tokens.colors.txt,
            }}
          >
            {m.content}
          </Box>
        ))}
        {sending && (
            <Box sx={{ maxWidth: '88%', p: 1.75, borderRadius: '15px', fontSize: 14, backgroundColor: tokens.colors.panel, border: `1px solid ${tokens.colors.line}` }}>
                <span style={{ color: tokens.colors.muted }}>Escribiendo…</span>
            </Box>
        )}
      </Box>

      <Box sx={{ p: 2, borderTop: `1px solid ${tokens.colors.line}`, display: 'flex', gap: 1 }}>
        <TextField
          fullWidth size="small" placeholder="Pregunta sobre este expediente…"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') handleSend(input); }}
        />
        <IconButton onClick={() => handleSend(input)} disabled={sending} sx={{ backgroundImage: tokens.gradient.main, color: '#08131a' }}>
          <SendIcon fontSize="small" />
        </IconButton>
      </Box>
    </Drawer>
  );
};

export default CaseCopilotDrawer;